module.exports = __webpack_public_path__ + "img/2234.de801879.svg";